import { FC, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
  Textarea,
} from '@features/ui';
import {
  CrRefundFormData,
  creditSchema,
  LeelooAccounts,
} from '@src/types/users.ts';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

interface AddCrRefundPopupProps {
  open: boolean;
  account: LeelooAccounts | null;
  onOpenChange: (open: boolean) => void;
  onSave: (data: CrRefundFormData) => void;
}
export const AddCrRefundPopup: FC<AddCrRefundPopupProps> = ({
  open,
  account,
  onOpenChange,
  onSave,
}) => {
  const {
    control,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<CrRefundFormData>({
    resolver: yupResolver(creditSchema),
  });

  useEffect(() => {
    if (open) {
      reset({
        amount: undefined,
        comment: undefined,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size={'xl'}>
        <DialogHeader>
          <DialogTitle className="text-2xl mb-[23px]">{`Credit / Refund Account ${account?.rithmic_account_name ?? ''}`}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit(onSave)}>
          <div className={'space-y-6 mb-10'}>
            <Controller
              control={control}
              name="amount"
              render={({ field }) => (
                <div>
                  <Label className="text-xs mb-2" htmlFor="amount">
                    Credit / Refund Amount $
                  </Label>
                  <Input
                    {...field}
                    id="amount"
                    placeholder={'Enter'}
                    textSize={'xs'}
                    type={'number'}
                    variant={'secondary'}
                  />
                  {errors.amount && (
                    <p className="mt-1 text-xs text-red-500">
                      {errors.amount.message}
                    </p>
                  )}
                </div>
              )}
            />
            <Controller
              control={control}
              name="comment"
              render={({ field }) => (
                <div>
                  <Label className="text-xs mb-2" htmlFor="amount">
                    Please give a reason for the credit refund of account
                  </Label>
                  <Textarea
                    {...field}
                    hiddenHeader
                    className={'h-20'}
                    id="comment"
                    placeholder={'Enter'}
                  />
                  {errors.comment && (
                    <p className="mt-1 text-xs text-red-500">
                      {errors.comment.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="flex items-center gap-10">
            <Button size={'sm'} type={'submit'} variant={'lime'}>
              Apply Credit Note
            </Button>
            <Button
              className={'w-20'}
              size={'sm'}
              onClick={() => {
                onOpenChange(false);
              }}
            >
              Close
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
